import React from 'react';

export default function ContentText({ text, styles }) {
  return <p className={' mb-6 font-light text-gray-500 md:text-lg text-left ' + styles}>{text}</p>;
}
